// Generated by xzor DI. Do not edit.
import { mount } from "@source-crafter/xzor-runtime";
import { Application } from "../main";
import Routes from "./Routes.xzor";

class Application$ extends Application {
}

mount(Routes, "app", new Application$());
